import {
  Paper,
  Text,
  TextInput,
  Textarea,
  Button,
  Group,
  SimpleGrid,
  createStyles,
  Container,
  Select,
} from '@mantine/core';
import { ContactIconsList } from '../ContactIcons/ContactIcons';
import bg from '../images/bg.svg';
import { useForm } from '@mantine/form';
import axios from 'axios';
import { showNotification } from '@mantine/notifications';

const useStyles = createStyles((theme) => {
  const BREAKPOINT = theme.fn.smallerThan('sm');

  return {
    wrapper: {
      display: 'flex',
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
      borderRadius: theme.radius.lg,
      padding: 4,
      border: `1px solid ${
        theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[2]
      }`,

      [BREAKPOINT]: {
        flexDirection: 'column',
      },
    },

    form: {
      boxSizing: 'border-box',
      flex: 1,
      padding: theme.spacing.xl,
      paddingLeft: theme.spacing.xl * 2,
      borderLeft: 0,

      [BREAKPOINT]: {
        padding: theme.spacing.md,
        paddingLeft: theme.spacing.md,
      },
    },

    fields: {
      marginTop: -12,
    },

    fieldInput: {
      flex: 1,

      '& + &': {
        marginLeft: theme.spacing.md,

        [BREAKPOINT]: {
          marginLeft: 0,
          marginTop: theme.spacing.md,
        },
      },
    },

    fieldsGroup: {
      display: 'flex',

      [BREAKPOINT]: {
        flexDirection: 'column',
      },
    },

    contacts: {
      boxSizing: 'border-box',
      position: 'relative',
      borderRadius: theme.radius.lg - 2,
      backgroundImage: `url(${bg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      border: '1px solid transparent',
      padding: theme.spacing.xl,
      flex: '0 0 280px',

      [BREAKPOINT]: {
        marginBottom: theme.spacing.sm,
        paddingLeft: theme.spacing.md,
      },
    },

    title: {
      marginBottom: theme.spacing.xl * 1.5,
      fontFamily: `Greycliff CF, ${theme.fontFamily}`,

      [BREAKPOINT]: {
        marginBottom: theme.spacing.xl,
      },
    },

    control: {
      [BREAKPOINT]: {
        flex: 1,
      },
    },
  };
});



export default function Contact() {
  const { classes } = useStyles();
  const form = useForm({
    initialValues: {
      company: '',
      city: '',
      name: '',
      email: '',
      phone: '',
      message: '',
      service: 'No service requested',
    },

    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
      phone: (value) => (/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(value) ? null : 'Invalid, try "1234567890" format'),
    },
  });

  const handleSubmit = () => {
    axios({
      method: "POST",
      url:"http://www.hazdepot.com/index.php",
      data:  form.values,
      headers: {
        'Content-Type': 'text/plain'
    }
    }).then((response)=>{
      if (response.data.status === 'success') {
        showNotification({
          title: 'Message sent!',
          message: 'Thank you for reaching out.',
        })
        form.reset();
      } else {
        showNotification({
          title: 'Message failed to send.',
          message: 'Please try again later, or reach out to us by phone.',
          color: 'red',
        })
      }
    })
  }

  return (
    <>
    <Container size="xl">
    <Paper shadow="md" radius="lg">
      <div className={classes.wrapper}>
        <div className={classes.contacts}>
          <Text size="lg" weight={700} className={classes.title} sx={{ color: '#fff' }}>
            Contact information
          </Text>

          <ContactIconsList variant="white" />
        </div>

        <form className={classes.form} onSubmit={form.onSubmit((values) => handleSubmit())}>
          <Text size="lg" weight={700} className={classes.title}>
            Contact Us/Get a quote
          </Text>

          <div className={classes.fields}>  
            <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]} style={{ marginTop: 10, zIndex: 2 }}>
              <TextInput label="Company Name" placeholder="Company" required {...form.getInputProps('company')}/>
              <TextInput label="City" placeholder="City" required {...form.getInputProps('city')}/>
            </SimpleGrid>
               
            <SimpleGrid cols={3} breakpoints={[{ maxWidth: 'sm', cols: 1 }]} style={{ marginTop: 10, zIndex: 2 }}>
              <TextInput label="Your Name" placeholder="Name" required {...form.getInputProps('name')}/>
              <TextInput label="Email" placeholder="your@email.com" required {...form.getInputProps('email')}/>
              <TextInput label="Phone Number" placeholder="0000000000" required {...form.getInputProps('phone')}/>
            </SimpleGrid>

            <Select
              data={['Inquiry','Chemical Waste Removal', 'Product Destruction - Incineration', 'Product Destruction - Shredding', 'Site Services', 'Transport']}
              placeholder="Inquiry"
              label="Service needed"
              {...form.getInputProps('service')}
            />

            <Textarea
              label="Your Message (Limit: 1000 Characters)"
              placeholder="If you would rather send us an attachment (e.g. chemical inventory), type 'inventory available' and we will contact you."
              minRows={3}
              maxLength="1000"
              required
              {...form.getInputProps('message')}
            />

            <div>We respect your privacy. Your information is for internal use only and will not be published.</div>    

            <Group position="right" mt="md">
              <Button type="submit" className={classes.control}>
                Send message
              </Button>
            </Group>
          </div>
        </form>
      </div>
    </Paper>
    </Container>
    </>
  );
}
